<template>
  <div class="calico-confirmation-page">
    <Modal
      v-if="!!show"
      header="View Business"
      @close="show = ''"
    >
      <template #content>
        <CalicoConfirmation
          v-if="show == 'confirm'"
          confirm="Confirm"
          message="This is a message"
        />
        <CalicoConfirmation
          v-if="show == 'success'"
          success="Success"
          message="This is a message"
        />
        <CalicoConfirmation
          v-if="show == 'error'"
          error="Error"
          message="This is a message"
        />
      </template>
      <template #footer>
        <button
          class="button-secondary"
          @click="show = ''"
        >
          Close
        </button>
      </template>
    </Modal>
    <span>
      <button
        class="button-primary"
        @click="show = 'confirm'"
      >Confirm</button>
    </span>
    <span>
      <button
        class="button-primary"
        @click="show = 'success'"
      >Success</button>
    </span>
    <span>
      <button
        class="button-primary"
        @click="show = 'error'"
      >Error</button>
    </span>
  </div>
</template>

<script lang="js">
import CalicoConfirmation from '@/components/pattern/confirmation/index.vue'
import Modal from '@/components/template/modal/index.vue'
export default {
  name: 'CalicoScoreMeterPage',
  components: {
    Modal,
    CalicoConfirmation
  },
  data() {
    return {
      show: ''
    }
  }
}
</script>

<style lang="scss">
.calico-confirmation-page {
  @include inset-space($space-xlarge);
  @include inline-space($space-small);
}
</style>